import MiniMap from "../../map/MiniMap";
import { MdMyLocation } from "react-icons/md";
import { LiaMapMarkerAltSolid } from "react-icons/lia";

interface LocationMapProps {
    onAddressSelect: (coordinates: { lat: number; lon: number }) => void;
    position?: [number?, number?]
}

const LocationMap = (props: LocationMapProps) => {

    const handleLocationChange = (coordinates: { lat: number; lon: number }) => {
        props.onAddressSelect(
            { lat: coordinates.lat, lon: coordinates.lon }
        );
    };

    return (
        <div>
            <h2 className="text-xl font-semibold pb-2">Betriebsstandort</h2>
            <div className="info-text flex gap-1 flex-col">
                <p>
                    Setze einen Marker
                    <span className="inline-flex items-center mx-1">
                        <LiaMapMarkerAltSolid size={20} className="bg-neutral-300 text-[#2880ca] rounded-full" />
                    </span>
                    für deinen Betriebsstandort. Du kannst dafür auch deinen
                    aktuellen Standort 
                     <span className="inline-flex items-center mx-1">
                        <MdMyLocation size={20} className="bg-white rounded-full p-0.5" />
                    </span>
                    verwenden.
                </p>
            </div>
            <div style={{ height: '80vh', maxWidth: '80vh' }}>
                <MiniMap onAddressSelect={handleLocationChange} position={props.position}></MiniMap>
            </div>
        </div>

    );
};

export default LocationMap;